import { Download } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

type Props = {
    onExportClicked: () => void;
};

export const DownloadMenuItem = ({ onExportClicked }: Props) => {
    return (
        <MenuItem onClick={onExportClicked}>
            <ListItemIcon>
                <Download fontSize="small" />
            </ListItemIcon>
            <ListItemText>Download</ListItemText>
        </MenuItem>
    );
};
